import React from 'react'
import {connect} from 'react-redux'
import {toJS} from '../../../util/ToJS'
import GrandmasterSolutions from '../components/GrandmasterSolutions'
import {chooseActiveSolution, selectActiveSolution} from '../../../redux/modules/grandmaster'
import {wrapDispatch} from 'multireducer'
import {showModal} from '../../../redux/modules/modal'
import {postToggleVote} from '../../../redux/modules/content'

let VisibleGrandmasterSolutions = (props) => {

  if (!props.batchHasPosted) {
    return null
  } else {
    return <GrandmasterSolutions {...props} />
  }
}

const mapStateToProps = state => (selectActiveSolution(state))

const mapDispatchToProps = dispatch => {
  return {
    chooseActiveSolution: solutionId => {
      dispatch(chooseActiveSolution(solutionId))
    },
    toggleVote: (type,id) => wrapDispatch(dispatch, 'grandmasterSolution')(postToggleVote(type,id)),
    report: (item) => {
      dispatch(showModal('REPORT',{
        item: item,
      }))
    }
  }
}

VisibleGrandmasterSolutions = connect(
  mapStateToProps,
  mapDispatchToProps
)(toJS(VisibleGrandmasterSolutions))

export default VisibleGrandmasterSolutions



// WEBPACK FOOTER //
// ./src/domains/grandmaster/containers/VisibleGrandmasterSolutions.js